import AurMenu, { AurMenuItem } from "../../common/aur-menu/AurMenu";
import { Workspace } from './model';
import { useState, useEffect } from "react";
import { launchWorkspace } from "../../../api/LaunchPointService";

interface LaunchWorkspaceMenuProps{
    workspaces: Workspace[];
    anchor: undefined | HTMLElement,
    show:boolean;
    onClose:() => void;
}

export const isRelativityDetailValid = (instanceId: string, artifactId: string | number): boolean => {
    if(instanceId === '00000000-0000-0000-0000-000000000000')
    {
        return false;
    }
    if(artifactId === 'Not Found')
    {
        return false;
    }
    return true;
}

export const LaunchWorkspaceMenu = (props: LaunchWorkspaceMenuProps) => {

    const [menuItems, setMenuItems] = useState<AurMenuItem[]>([]);

    useEffect(() => {
        const workspaceMenuItems = props.workspaces.map((workspace: Workspace) => {
            // Disable invalid items
            let css = 'launch-workspace-menu-item';
            const isValid = isRelativityDetailValid(workspace.instanceId, workspace.artifactID);
            if (!isValid) {
                css += ' Mui-disabled';
            }

            return {
                label: workspace.name,
                onClick: () => {
                  launchWorkspace(workspace.instanceId, workspace.artifactID);
                },
                tooltip: workspace.name,
                cssClassName: css
              }
        })
        setMenuItems(workspaceMenuItems);
    },[]);

    return(
        <AurMenu
            shouldShow={props.show}
            onClose={props.onClose}
            menuItems={menuItems}
            anchorElement={props.anchor}
            direction={'right'}
        />
    );
}